<script setup>

import {onMounted, reactive, watch} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import XmlViewer from 'vue3-xml-viewer'
import VueJsonPretty from "vue-json-pretty";
import {ToastUtil} from "@/Utils/ToastUtil";
import VuePdfEmbed from "vue-pdf-embed";


const props = defineProps({
  status: String,
  claimId: String
});

const emit = defineEmits(['closed']);

const data = reactive({
  loading: true,
  dialog: true,
  rawJson: null,
  rawXML: null,
  rawPdf: null
});

const close = () => {
  emit('closed');
}

const loadRawData = async () => {
  if(props.claimId) {
    data.loading = true;
    // Get S3 signed download url for this claim's raw data
    await ApiWrapper.post('claims', 'get-raw-data', {
      claimId: props.claimId
    })
    .then(async (response) => {
      // Load file from S3 signed download url
      await ApiWrapper.getFile(response.url)
      .then(function (response2) {
        data.rawJson = response2.json ? JSON.parse(response2.json) : null;
        data.rawXML = response2.xml;
        data.rawPdf = response.url;
      })
      .catch(e => {
        ToastUtil.error(e);
      })
      .finally(() => {
          data.loading = false;
      });
    })
    .catch((e) => {
      ToastUtil.error(e);
      data.loading = false;
    });
  }
}

watch(() => props.status, async (val) => {
  if(props.status === 'open') {
    await loadRawData();
  }
});

</script>

<template>
  <div class="pa-4 text-center">
    <v-dialog
        v-if="props.status === 'open'"
        v-model="data.dialog"
        max-width="1400"
        persistent
        @click:outside="close"
        scrollable
    >
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Raw Claim File</v-toolbar-title>
          <v-progress-linear
              :active="data.loading"
              :indeterminate="data.loading"
              absolute
              bottom
              color="primary"
          >
          </v-progress-linear>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <div v-if="data.rawJson !== null">
                <vue-json-pretty
                    :data="data.rawJson"
                    :showLine="true"
                    :showDoubleQuotes="true"
                    :showKeyValueSpace="true"
                    :collapsedOnClickBrackets="true"
                    :deep="4"
                />
              </div>

              <div v-if="data.rawXML !== null">
                <XmlViewer :xml="data.rawXML" />
              </div>

              <div v-if="data.rawPdf !== null">
                <VuePdfEmbed :source="data.rawPdf" text-layer/>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text="Close"
              variant="plain"
              @click="close"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

</style>